<div class="marg">
    <div class="login">
        <div class="row">
            <div class="left">
                <img [src]="logoImage" alt="login" class="spurt-img hello" *ngIf="logoImage">
                <img src="../../../../../assets/images/sp-logo.svg" alt="login" class="spurt-img hi" *ngIf="!logoImage">
                <div class="txt">
                    A quick and easy Node JS and Angular eCommerce solution to develop an awesome e-commerce Website
                </div>
            </div>
            <div class="right">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
    <!-- <div class="ttt"> Kellton Tech India (P) Ltd. © 2022. All Rights Reserved</div> -->
</div>